import React from 'react'

const ProgressBar = (props) => {
    return <div className="progress" style={{
        height: '25px',
        width: "100%"
    }}>
        <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            aria-valuenow={props.progress}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{
                width: props.progress + '%'
            }} />
    </div>
}

export default ProgressBar





// WEBPACK FOOTER //
// ./src/common/progress-bar/progressbar.component.jsx